import { useParams } from 'react-router-dom';
import { useGetPlaceById } from '../../api/get-place-by-id';
import { ToggleLinked } from '../toggle-linked';
import { ToggleCloud } from '../toggle-cloud';
import ToggleOnlyDedicate from '@/Components/place/toggle-only-dedicate/ToggleOnlyDedicate';
import styles from './toggle-group.module.scss';
import { useAppSelector } from '@/_store/hooks';
import { selectUser } from '@/_store/modules/auth/selectors';
import { ROLE_TYPES } from '@/Interfaces/Data';
import { Skeleton } from '@/_config/lib/react-native-skeleton';
import { PostPaidToggle } from '@/_features/post-paid/components/post-paid-toggle/post-paid-toggle';
import { AccessPermission } from '@/_components/access-permission';

export const ToggleGroup = () => {
  const { placeId } = useParams<{ placeId: string }>();
  const { managerLogType } = useAppSelector(selectUser) || {};

  const {
    data: place,
    isLoading,
    error,
  } = useGetPlaceById({
    placeId: placeId || '',
  });

  const canActivePostPaidToggle =
    managerLogType !== ROLE_TYPES.LOGISTIC_OPERATOR;

  if (!place || isLoading || error) {
    return (
      <div className={styles.toggleGroupContainer}>
        <div className={styles.toggleGroup}>
          <div className={styles.postPaidToggle}>
            <Skeleton width={52} height={32} borderRadius={16} />
            <Skeleton width={100} height={16} borderRadius={4} />
          </div>
          <div className={styles.postPaidToggle}>
            <Skeleton width={52} height={32} borderRadius={16} />
            <Skeleton width={100} height={16} borderRadius={4} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.toggleGroup}>
      <ToggleLinked placeId={place._id} isLinked={place?.isLinked || false} />
      <PostPaidToggle
        place={place}
        canActivePostPaidToggle={canActivePostPaidToggle}
      />
      <ToggleCloud placeId={place._id} isCloud={place?.isCloud || false} />

      <AccessPermission permissionKey="place.dedicateOrder">
        <ToggleOnlyDedicate place={place} />
      </AccessPermission>
    </div>
  );
};
